import { OrganType, CaseStatus } from '@/api/apis/case';
import { getQuestionnaireEditControlState } from '@/utils/helpers';

type TrialProgramLike = {
  id?: string;
  name?: string;
  organ?: string | null;
  isActive?: boolean | null;
};

type Params = {
  status?: CaseStatus;
  prevOrganType?: OrganType;
  nextOrganType?: OrganType;
  prevTxCenterTrialPrograms?: TrialProgramLike[] | null;
  nextTxCenterTrialPrograms?: TrialProgramLike[] | null;
  prevIsQuestionaryEditAllowed?: boolean | null;
  nextIsQuestionaryEditAllowed?: boolean | null;
};

type Result = {
  prevQuestionaryEditAllowed: boolean;
  nextQuestionaryEditAllowed: boolean;
  hasQuestionaryEditAllowedChanged: boolean;
};

export const getQuestionaryEditAllowanceChange = ({
  status,
  prevOrganType,
  nextOrganType,
  prevTxCenterTrialPrograms,
  nextTxCenterTrialPrograms,
  prevIsQuestionaryEditAllowed,
  nextIsQuestionaryEditAllowed,
}: Params): Result => {
  const prevQuestionaryEditControl = getQuestionnaireEditControlState({
    status,
    organType: prevOrganType,
    txCenterTrialPrograms: prevTxCenterTrialPrograms,
  });

  const nextQuestionaryEditControl = getQuestionnaireEditControlState({
    status,
    organType: nextOrganType,
    txCenterTrialPrograms: nextTxCenterTrialPrograms,
  });

  const normalizedPrevQuestionaryEditAllowed = prevQuestionaryEditControl.forceEnabled
    ? true
    : !!prevIsQuestionaryEditAllowed;

  const normalizedNextQuestionaryEditAllowed = nextQuestionaryEditControl.forceEnabled
    ? true
    : !!nextIsQuestionaryEditAllowed;

  return {
    prevQuestionaryEditAllowed: normalizedPrevQuestionaryEditAllowed,
    nextQuestionaryEditAllowed: normalizedNextQuestionaryEditAllowed,
    hasQuestionaryEditAllowedChanged: normalizedPrevQuestionaryEditAllowed !== normalizedNextQuestionaryEditAllowed,
  };
};
